import { render, staticRenderFns } from "./CarroselClimaMonitoramentoAgricola.vue?vue&type=template&id=789c1583&scoped=true&lang=pug"
import script from "./CarroselClimaMonitoramentoAgricola.vue?vue&type=script&lang=js"
export * from "./CarroselClimaMonitoramentoAgricola.vue?vue&type=script&lang=js"
import style0 from "./CarroselClimaMonitoramentoAgricola.vue?vue&type=style&index=0&id=789c1583&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789c1583",
  null
  
)

export default component.exports